module.exports = __webpack_public_path__ + "img/Rail_acc_1.36c4c088.jpg";